module.exports = __webpack_public_path__ + "static/media/assistante.86670447.jpg";